import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const iconWrappedFn = /* @__PURE__ */ createRecipe('icon-wrapped', {
  "variant": "filled",
  "shape": "rounded",
  "color": "neutral",
  "size": "m"
}, [
  {
    "variant": "filled",
    "color": "primary",
    "css": {
      "color": "neutral.foreground.1.onBrand.enabled",
      "backgroundColor": "primary.background.2.enabled"
    }
  },
  {
    "variant": "filled",
    "color": "neutral",
    "css": {
      "color": "neutral.foreground.2.onBrand.enabled",
      "backgroundColor": "neutral.background.2.enabled"
    }
  },
  {
    "variant": "outlined",
    "color": "primary",
    "css": {
      "color": "primary.foreground.1.enabled",
      "borderColor": "primary.stroke.2.enabled"
    }
  },
  {
    "variant": "outlined",
    "color": "neutral",
    "css": {
      "color": "neutral.foreground.1.enabled",
      "borderColor": "neutral.stroke.2.enabled"
    }
  }
])

const iconWrappedVariantMap = {
  "variant": [
    "unstyled",
    "filled",
    "outlined"
  ],
  "shape": [
    "unstyled",
    "rounded",
    "square"
  ],
  "color": [
    "unstyled",
    "primary",
    "neutral"
  ],
  "size": [
    "l",
    "m",
    "s"
  ]
}

const iconWrappedVariantKeys = Object.keys(iconWrappedVariantMap)

export const iconWrapped = /* @__PURE__ */ Object.assign(memo(iconWrappedFn.recipeFn), {
  __recipe__: true,
  __name__: 'iconWrapped',
  __getCompoundVariantCss__: iconWrappedFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: iconWrappedVariantKeys,
  variantMap: iconWrappedVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, iconWrappedVariantKeys)
  },
  getVariantProps: iconWrappedFn.getVariantProps,
})